import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~api/shipping';
import { Soco } from '~api/soco';

export const methods = createAsyncThunk(
  'shipping/methods',
  async (params) =>
    await api
      .getShippingMethods(params)
      .then(({ data }) => data)
      .catch(console.log),
);
export const payment = createAsyncThunk(
  'shipping/payment',
  async (payload) =>
    await api
      .postUserMeShippings(payload)
      .then(({ data }) => data)
      .catch(console.log),
);

export const getAddressFromCoordinates = createAsyncThunk(
  'shipping/getAddressFromCoordinates',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await api.getAddressFromCoordinates(params);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAddressSuggestions = createAsyncThunk(
  'shipping/getAddressSuggestions',
  async (params) =>
    await api
      .getAddressSuggestions(params)
      .then(({ data }) => {
        return data;
      })
      .catch(console.log),
);

export const updateDefaultAddress = createAsyncThunk(
  'shipping/updateDefaultAddress',
  async (idAddress) => {
    try {
      const response = await Soco.updateDefaultAddress(idAddress);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);
